import React from 'react';
import Hendrick from './Hendrick';
import Rimon from './Rimon.jsx';
import Jennie from './Jennie.jsx';
import Kevin from './Kevin.jsx';
import Bridged from './Bridged.jsx';

const AllComponent = () => {
  return (
    <div>
        <Hendrick />
        <Rimon />
         <Jennie />
        <Kevin />
       <Bridged />
    </div>
  )
}

export default AllComponent;
